import { ISetVehicleImageUrl } from "../interfaces/garage.interface";

function setVehicleImageUrl(data: string): ISetVehicleImageUrl {
  return {
    type: "SET_VEHICLE_IMAGE_URL",
    data,
  };
}
export default setVehicleImageUrl;
